import { useMutation } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export function useCreateDemoSession() {
  return useMutation(trpcOptions.public.createDemoSession.mutationOptions())
}
